import { enableDataExportUsageEnhancements, planUsageTabsOverride } from '@gonfalon/dogfood-flags/dogfood-flags';

import type { Subscription, UsageTabKey } from '../../types';
import { UsageTab } from '../../types';
import { TabVisibility, usageTabConfig } from '../constants/usageTabConfig';

import {
  getTabsReplacedByCombined,
  getVisibleUsageTabs,
  tabKeyToOverrideKey,
  TabOverrideValue,
} from './getVisibleUsageTabs';

/**
 * Returns tabs that are visible in the diagnostic usage page.
 */
export function getVisibleDiagnosticTabs(limits?: Subscription['_limits']): UsageTabKey[] {
  const result = new Set<UsageTabKey>([]);

  const overrideConfig = planUsageTabsOverride();
  const visibleUsageTabs = getVisibleUsageTabs(limits);
  const replacedTabs = getTabsReplacedByCombined(limits);

  for (const [tab, config] of Object.entries(usageTabConfig)) {
    const override = overrideConfig?.[tabKeyToOverrideKey[tab as UsageTabKey]] ?? [];

    if (visibleUsageTabs.includes(tab as UsageTabKey)) {
      continue;
    }

    if (replacedTabs.includes(tab as UsageTabKey)) {
      if (!override.includes(TabOverrideValue.DIAGNOSTIC_DISABLED)) {
        result.add(tab as UsageTabKey);
      }
      continue;
    }

    if (config.visibility === TabVisibility.HIDDEN) {
      if (tab === UsageTab.DATA_EXPORT_COMBINED && !enableDataExportUsageEnhancements()) {
        continue;
      }
      if (override.includes(TabOverrideValue.DIAGNOSTIC_ENABLED)) {
        result.add(tab as UsageTabKey);
      }
      continue;
    }

    if (
      (config.visibility === TabVisibility.DIAGNOSTIC_ONLY || config.visibility === TabVisibility.PLAN_OR_DIAGNOSTIC) &&
      !override.includes(TabOverrideValue.DIAGNOSTIC_DISABLED)
    ) {
      result.add(tab as UsageTabKey);
      continue;
    }

    if (override.includes(TabOverrideValue.DIAGNOSTIC_ENABLED)) {
      result.add(tab as UsageTabKey);
    }
  }

  return Array.from(result);
}
